import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { useAtomValue } from 'jotai';
import { isProjectDraggingAtom } from '../../../../atoms/v3/taskAtoms';
import { Project } from '../../../../types/project';

interface DraggableDesktopProjectItemProps {
  project: Project;
  onClick: () => void;
}

/**
 * 可拖拽的桌面项目项组件
 * 包装项目按钮，使其可拖拽到不同文件夹
 */
export const DraggableDesktopProjectItem: React.FC<DraggableDesktopProjectItemProps> = ({
  project,
  onClick
}) => {
  const isProjectDragging = useAtomValue(isProjectDraggingAtom);

  // 检测是否为触摸设备
  const isTouchDevice = 'ontouchstart' in window ||
                        navigator.maxTouchPoints > 0 ||
                        window.matchMedia('(pointer: coarse)').matches;

  // 使用dnd-kit的useDraggable钩子
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `desktop-project-${project.id}`,
    data: {
      type: 'project-item',
      projectId: project.id,
      project: project,
      currentFolderId: project.folderId || null
    }
  });

  // 计算拖拽变换样式
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  // 拖拽时的样式
  const dragStyle = isDragging ? {
    opacity: 0.5,
    zIndex: 1000,
  } : {};

  return (
    <button
      ref={setNodeRef}
      style={{ ...style, ...dragStyle }}
      {...(isTouchDevice ? {} : listeners)} // 桌面端直接启用拖拽
      {...attributes}
      onClick={onClick}
      className={`
        w-full text-left px-3 py-2 rounded-ios-md text-ios-body text-ios-gray dark:text-ios-dark-gray 
        hover:bg-ios-gray6 dark:hover:bg-ios-dark-gray4/50 truncate transition-colors
        ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}
        ${isProjectDragging && !isDragging ? 'pointer-events-none' : ''}
      `}
    >
      {project.title}
    </button>
  );
};
